import { cnpjConfig } from "@utils/fiscal/cnpj/config";

const CNPJ_LENGTH = 14;
const BASE_LENGTH = 12;

const WEIGHTS_1 = [5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];
const WEIGHTS_2 = [6, 5, 4, 3, 2, 9, 8, 7, 6, 5, 4, 3, 2];

const getCharValue = (char: string): number => {
  const code = char.toUpperCase().charCodeAt(0);

  if (code >= 48 && code <= 57) return code - 48;
  if (code >= 65 && code <= 90) return code - 48;

  throw new Error(`Caractere inválido: ${char}`);
};

const calculateDv = (base: string, weights: number[]): number => {
  const sum = base.split("").reduce((total, char, index) => {
    return total + getCharValue(char) * weights[index];
  }, 0);

  const remainder = sum % 11;
  return remainder < 2 ? 0 : 11 - remainder;
};

const isRepeated = (value: string): boolean => /^(\w)\1+$/.test(value);

export const isValidCnpj = (
  value: string,
  allow = cnpjConfig.allowAlphanumeric
): boolean => {
  if (value.length !== CNPJ_LENGTH) return false;
  if (isRepeated(value)) return false;

  if (!allow && /[A-Z]/.test(value)) {
    return false;
  }

  const base = value.slice(0, BASE_LENGTH);

  const dv1 = calculateDv(base, WEIGHTS_1);
  const dv2 = calculateDv(`${base}${dv1}`, WEIGHTS_2);

  return value.endsWith(`${dv1}${dv2}`);
};
